// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ISaveUserEstimationScoreFactRequest,
  TSaveUserEstimationScoreFactModel,
  IMappers,
  TSaveUserEstimationScoreFactResponse,
  ISaveUserEstimationScoreFactResponseError,
} from './types';

export const defaultConfig: TSaveUserEstimationScoreFactModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v1/save-user-estimation-score-fact/',
  requestType: 'json',
} as TSaveUserEstimationScoreFactModel;

export function createSaveUserEstimationScoreFactModel(
  parameters: ISaveUserEstimationScoreFactRequest,
): TSaveUserEstimationScoreFactModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISaveUserEstimationScoreFactOptions<TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400>;
  parameters: ISaveUserEstimationScoreFactRequest;
}

export async function fetchSaveUserEstimationScoreFact<TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISaveUserEstimationScoreFactOptions<TResponse400>): Promise<TSaveUserEstimationScoreFactResponse | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createSaveUserEstimationScoreFactModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as ISaveUserEstimationScoreFactResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TSaveUserEstimationScoreFactResponse;
}
